import { render, staticRenderFns } from "./FormEvento.vue?vue&type=template&id=1c375bc1"
import script from "./FormEvento.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormEvento.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports